<template>
  <!-- eslint-disable vue/require-component-is -->
  <component v-bind="linkProps(to)" @click="handleClick">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    trackId: {
      type: String,
      default: '',
    },
    trackPayload: {
      type: Object,
      default: () => ({}),
    },
    trackOnce: {
      type: Boolean,
      default: false,
    },
    useFullPath: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    linkProps(url) {
      if (isExternal(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener',
        }
      }
      // If useFullPath is true, use anchor tag with full path (no hash)
      if (this.useFullPath) {
        return {
          is: 'a',
          href: url,
        }
      }
      return {
        is: 'router-link',
        to: url,
      }
    },
    handleTrackEvent() {
      const eventName = `${this.trackId}_link_clicked`
      const payload = {
        link_url: this.to,
        ...this.trackPayload,
      }

      if (this.trackOnce) {
        this.$track.trackOnce(eventName, payload)
      } else {
        this.$track.event(eventName, payload)
      }
    },
    handleClick(event) {
      if (this.trackId) {
        this.handleTrackEvent()
      }
      // If useFullPath is true, prevent default router-link behavior and navigate directly
      if (this.useFullPath && !isExternal(this.to)) {
        event.preventDefault()
        window.location.href = this.to
        return
      }
      this.$emit('click', event)
    },
  },
}
</script>
